/* eslint-disable @typescript-eslint/naming-convention */
import style from './style.module.scss';
import {ShareButton} from 'components/ShareButton';
import {Typography} from 'components/Typography';
import {AddToFavoritesButton} from 'modules/product-card-actions/components/AddToFavoritesButton';
import {Article} from 'modules/product-card/components/Article';
import {PRODUCT_SHARE_BUTTON_LABEL} from 'modules/product-card/constants';
import {IProduct} from 'modules/product-card/models/ProductResponse';
import {ProductHeaderLabels} from '../ProductHeaderShields';
import {Col, Row} from 'components/Grid';
import {useSanitizeString} from 'core/hooks/useSanitizeString';
import {WishlistButton} from 'modules/wishlist_new/components/WishlistButton';
import {ProductOutOfStockLine} from 'modules/product-card/pages/ProductPage/ProductOutOfStockLine';

type TProductHeaderProps = Partial<
    Pick<IProduct, 'labels' | 'id' | 'catalogRusName' | 'title' | 'similar' | 'canBuy' | 'canReserve'>
>;

// eslint-disable-next-line complexity
export const ProductHeader = (props: TProductHeaderProps) => {
    const {labels = [], id, catalogRusName, title, canBuy, canReserve, similar} = props;
    const titleHtml = useSanitizeString(title);
    const isOutOfStockLineVisible =
        (!canBuy && !canReserve && similar && 'offer' === similar.type) ||
        (false === canBuy && false === canReserve && !similar);

    return (
        <Row>
            <Col className={style.titleCol}>
                {isOutOfStockLineVisible && <ProductOutOfStockLine hasSimilar={Boolean(similar)} />}
                <div className={style.shields}>
                    {0 < labels.length && <ProductHeaderLabels />}
                    <div className={style.tablet}>
                        <div className={style.headerActions}>
                            {id && <WishlistButton id={id} />}
                            <ShareButton labelText={PRODUCT_SHARE_BUTTON_LABEL} />
                            <AddToFavoritesButton id={id} />
                        </div>
                    </div>
                </div>
                <div className={style.headerTitleContainer}>
                    <Typography
                        className={style.headerTitle}
                        dangerouslySetInnerHTML={{__html: titleHtml}}
                        data-skeleton-item={true}
                        element={'h1'}
                        variant={'ch-display-42-reg'}
                    />
                </div>
                <div className={style.infoHeaderRow}>
                    <div className={style.infoHeaderRowData}>
                        {0 < labels.length && (
                            <div className={style.desktop}>
                                <ProductHeaderLabels />
                            </div>
                        )}
                        <div className={style.infoHeaderRowDataText} data-skeleton-item={true}>
                            <div className={style.article}>{id && <Article id={id} />}</div>
                            {catalogRusName && (
                                <>
                                    <div className={style.infoHeaderRowVerticalLine} />
                                    <Typography className={style.additionalInfo} variant={'label-14-r-fluid'}>
                                        {catalogRusName}
                                    </Typography>
                                </>
                            )}
                        </div>
                    </div>
                    <div className={style.desktop}>
                        <div className={style.headerActions}>
                            {id && <WishlistButton id={id} />}
                            <ShareButton labelText={PRODUCT_SHARE_BUTTON_LABEL} />
                            <AddToFavoritesButton id={id} className={style.addToFavouriteButton} />
                        </div>
                    </div>
                </div>
            </Col>
        </Row>
    );
};
